import { InputMask } from "@react-input/mask";
import FieldValidationError from "../Forms/Element/FieldValidationError";

const CpfInput = (props) => {

    return (
        <>
            <InputMask
                mask="___.___.___-__"
                replacement={{ _: /\d/ }}
                className="form-control input-default"
                {...props}
            />
            <FieldValidationError error={props.error} />
        </>
    )
}

export default CpfInput;